<template>
    <div class="subscription-item card-body" v-if="p_item.isVisible">
        <Div type="button" class="card-header" :style="p_item.isActive ? 'background-color: var(--subscription-color);color:white' : '' ">
            <div style="display: flex;flex-direction: row;justify-content: center; ">
                <div>{{ p_item.title }}</div>
                <!-- <div v-if="p_item.isActive" style="font-size: 8pt;" >&nbsp;(Active)</div>                 -->
            </div>
            
        </Div>
        <div class="content">
            <div class="administrator-button-bar">
                <button class="administrator-button" @click="onSave(p_item)" v-show="isDirty">
                    Save
                </button>
                <button class="administrator-button" @click="onActivate(p_item)" v-if="isValid && !isDirty && !p_item.isActive" title="Marks the subscription as active for member purchase" aria-label="Marks the subscription as active for member purchase">
                    Activate
                </button>
                <button class="administrator-button button-delete-2" @click="onDeactivate(p_item)" v-if="p_item.isActive" title="Deactivates subscription" aria-label="Deactivates subscription">
                    Deactivate
                </button>
                <button class="administrator-button button-delete" @click="onDelete(p_item)" v-if="!isDirty && !p_item.isActive" title="Deletes subscription" aria-label="Deletes subscription">
                    Delete
                </button>
            </div>
            
            <div class="subscription-input-container-grid">            

                <div class="subscription-input-container">
                    <span class="subscription-name">Title</span>
                    <input @change="markDirty" class="subscription-input-item" type="text" v-model="p_item.title" maxlength="30" title="Title of subscription" aria-label="Title of subscription" :disabled="fetchingData || p_item.isActive" />
                </div>
                

                <div style="display:flex;flex-direction:column">
                    <div class="subscription-input-container">
                        <span class="subscription-name">Category</span>
                        <select @change="markDirty" class="subscription-input-item-select" v-model="p_item.categoryId" title="Select subscription category" aria-label="Select subscription category" :disabled="fetchingData || p_item.isActive" >
                            <option v-for="category in categoryList" :key="category.globalId" :value="category.globalId">{{ category.categoryText }}</option>
                        </select>
                    </div>
                </div>

                <div class="subscription-input-container">
                    <span class="subscription-name">Price</span>                
                    <input @change="markDirty" class="subscription-input-item administrator-input-item-numeric" type="number" min="1" max="1000" step="1" v-model.number="p_item.price" title="Price of subscription" aria-label="Price of subscription" :disabled="fetchingData || p_item.isActive" />
                </div>
                
                <!-- For Future -->
                <div style="display:flex;flex-direction:column" v-show="false">
                    <div class="subscription-input-container">
                        <span class="subscription-name">Site</span>
                        <select @change="markDirty" class="subscription-input-item-select" v-model="p_item.siteSettings" :disabled="fetchingData || p_item.isActive">
                        <option v-bind:value="'sitesetting01'">Main</option>
                        <option v-bind:value="'sitesetting02'">{{ locations.find(item => item.siteSetting === "siteSetting02")?.siteName ?? "Alt 2" }}</option>
                        <option v-bind:value="'sitesetting03'">{{ locations.find(item => item.siteSetting === "siteSetting03")?.siteName ?? "Alt 3" }}</option>
                        <option v-bind:value="'sitesetting04'">{{ locations.find(item => item.siteSetting === "siteSetting04")?.siteName ?? "Alt 4" }}</option>
                        <option v-bind:value="'sitesetting05'">{{ locations.find(item => item.siteSetting === "siteSetting05")?.siteName ?? "Alt 5" }}</option>
                        <option v-bind:value="'sitesetting06'">{{ locations.find(item => item.siteSetting === "siteSetting06")?.siteName ?? "Alt 6" }}</option>
                        <option v-bind:value="'sitesetting07'">{{ locations.find(item => item.siteSetting === "siteSetting07")?.siteName ?? "Alt 7" }}</option>
                        <option v-bind:value="'sitesetting08'">{{ locations.find(item => item.siteSetting === "siteSetting08")?.siteName ?? "Alt 8" }}</option>
                        <option v-bind:value="'sitesetting09'">{{ locations.find(item => item.siteSetting === "siteSetting09")?.siteName ?? "Alt 9" }}</option>
                        <option v-bind:value="'sitesetting10'">{{ locations.find(item => item.siteSetting === "siteSetting10")?.siteName ?? "Alt 10" }}</option>
                    </select>
                    </div>
                </div>

                <div class="subscription-input-container">
                    <span class="subscription-name">Description</span>                
                    <textarea @change="markDirty" class="subscription-input-item" maxlength="500" name="message" rows="10" cols="30" v-model="p_item.description" title="Description of subscription" aria-label="Description of subscription" :disabled="fetchingData || p_item.isActive"></textarea>
                </div>
                               
                <div class="subscription-input-container" v-if="p_item.isActive">
                    <span class="subscription-name" style="display: flex;flex-direction: row;justify-content: center; gap: 20px;" v-show="false">
                        <div>URL Link</div> 
                        <div><img src="/images/icons/copy.png" class="button-link" @click="copyPurchaseLink" style="width:30px" title="Copy Subscription Purchase URL" /></div>
                    </span>



                    <span class="subscription-name" style="display: flex;flex-direction: row;justify-content: center; gap: 20px;" v-show="false">
                        <div>QR Code</div> 
                        <div><img src="/images/icons/printer.png" class="button-link" @click="onSetupQrCode" style="width:30px" title="Print Station QR Code"  /></div>
                    </span>

                    <input class="subscription-input-item" type="text" v-model="purchaseLink" title="Subscription Purchase URL" aria-label="Subscription Purchase URL" readonly v-if="false"/>
                </div>                                
            </div>            
        </div>
    </div>
</template>

<script>
import { ref} from "vue";
import apiSubscription from "@/api/apiSubscription";
import { computed, getCurrentInstance } from "@vue/runtime-core";
import Helper from "@/common/helper";

export default {
    props: ["item", "categoryList", "locations"],
    components: {},
    setup(props, { emit }) {


        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;

        const p_item = ref(props.item);
        
        // For now this is hard-coded.
        p_item.value.siteSettings = "sitesetting01";
        
        const isDirty = ref(false);            

        const isValid = computed(() => {
            
            console.log("p_item.value", p_item.value?.siteSettings)
            return (p_item.value?.categoryId != null) && 
                (p_item.value?.siteSettings != null) &&
                (p_item.value?.price > 0);
        });

        const onSave = async (item) => {
            try {
                emitter.emit("server-call-start", "Saving data...");                
                
                await apiSubscription.save(item)
                isDirty.value = false;
                emit("on-dirty", false);            
                                        
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error saving data", err]);
            }
            emitter.emit("server-call-stop");
        };


        const onDelete = (item) => {
            emit("on-delete", item);
        };

        const markDirty = () => {
            console.log("dddd")
            if (!isDirty.value) {
                emit("on-dirty", true);
            }
            isDirty.value = true;
        };    

        const onActivate = (item) => {
            emit("on-activate", item);
        };

        const onDeactivate = (item) => {
            emit("on-deactivate", item);
        };

        const purchaseLink = ref(Helper.subscriptionPurchaseCodeForActive(window, p_item.value.globalId));        
        const copyPurchaseLink = () => {                        
            var dummy = document.createElement("textarea");
            document.body.appendChild(dummy);
            dummy.value = purchaseLink.value;
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);            
        };    
        

        const onSetupQrCode = () => {
            emit("on-qrCode", purchaseLink.value, p_item.value.title)            
        };
        
        return {
            Helper,
            onSave,
            onDelete,
            p_item,
            isDirty,
            markDirty,            
            onActivate,
            onDeactivate,
            copyPurchaseLink,
            purchaseLink,
            onSetupQrCode,
            isValid,
        };
    }
};
</script>

<style scoped>
.subscription-item {    
    width: 450px;
    min-width: 100px;
}

.subscription-input-container {
    display: flex;
    /* justify-content: space-between; */
    margin: 10px;
    padding-left: 5%;
}

.subscription-input-container-grid {
    display: flex;
    flex-direction: column;
    margin: 10px 10px 10px 0px;
}

.subscription-input-item {
    width: 200px;
}

.subscription-name {
    width: 150px;
}

.setting-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
    width: 100%;
}

.setting-header-bar {
    width: 100%;
}

.setting-header-label {
    /* color: var(--card-body-border); */
    text-transform: uppercase;
    font-size: 10pt;
}

.subscription-input-item-select {
    width: 210px;
}
</style>
